<template>
    <!--    <div style="float: right;">-->
    <!--      <div class="table-toolbar">-->
    <!--        <a-button type="primary" @click="onEdit">编辑-->
    <!--          <template #icon>-->
    <!--            <form-outlined />-->
    <!--          </template>-->
    <!--        </a-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="top">
        <div class="imgBox">
            <img v-if="detail.companyLogo" style="width: 100%;height: 100%;" :src="getImg(detail.companyLogo)"/>
            <img v-else style="width: 100%;height: 100%;"
                 src="@/assets/home/user-qy-avatar.png"/>
        </div>
        <div class="rightBox">
            <div class="topBox">
                <p class="name">{{ detail.companyName }}</p>
                <div class="user-type">企业用户</div>
            </div>
            <div class="second">
                <!--           <div class="address">地址：{{ detail.provject }}{{ detail.detailedAddress }}</div> -->
                <div class="name"><img style="margin: 0 5px 3px 0;" src="../../../../assets/home/user-icon-05.png" alt="">
                    {{ detail.linkman }}
                </div>
                <div class="name">
                    <img style="margin: 0 5px 4px 0;" src="../../../../assets/home/user-phone.png" alt="">{{
                        detail.phone
                    }}
                </div>
            </div>
        </div>
    </div>
    <div class="info-content">
        <div class="title">
            <div class="tit">企业信息</div>
            <div class="btn" @click="onEdit">
                <img src="../../../../assets/home/user-icon-01.png" alt="">
                编辑
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="item">
                    <div class="name">邮政编码：</div>
                    <div class="value">
                        {{ detail.postalCode }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">统一社会信用代码：</div>
                    <div class="value">
                        {{ detail.oraganizationCode }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">企业法人：</div>
                    <div class="value">
                        {{ detail.corporation }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">法人电话：</div>
                    <div class="value">
                        {{ detail.contactsMobile }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">地址：</div>
                    <div class="value">
                        {{ detail.provject }}{{ detail.detailedAddress }}
                    </div>
                </div>
            </div>
            <div class="middle">
                <div class="item">
                    <div class="name">注册时间（企业成立时间）：</div>
                    <div class="value">
                        {{ detail.registerTime?.substr(0, 10) }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">企业性质：</div>
                    <div class="value">
                        <dict-render :dict-obj="dictObjs['businessScope']" v-if="detail.businessScope"
                                     :text="detail.businessScope"></dict-render>
                    </div>
                </div>
                <div class="item">
                    <div class="name">联系人：</div>
                    <div class="value">
                        {{ detail.linkman }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">联系电话：</div>
                    <div class="value">
                        {{ detail.phone }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">营业执照(PDF格式)：</div>
                    <div class="value">
                        <file-upload v-model:value="detail.licenceFile" :showBtn="false" disabled/>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="item">
                    <div class="name">注册资本：</div>
                    <div class="value">
                        {{ detail.registerMoney }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">所属园区：</div>
                    <div class="value">
                        {{ detail.baseName }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">所属领域：</div>
                    <div class="value">
                        <dict-render :dict-obj="dictObjs['corpbelong_type']" v-if="detail.companyDomain" :text="detail.companyDomain"></dict-render>
                    </div>
                </div>
                <div class="item">
                    <div class="name">企业邮箱：</div>
                    <div class="value">
                        {{ detail.comEmail }}
                    </div>
                </div>
                <div class="item">
                    <div class="name">企业法人身份证：</div>
                    <div class="value">
                        <file-upload v-model:value="detail.legalPersonCard" :showBtn="false" disabled/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getCorpInfo" @onCloseModel="onCloseModel"/>
</template>

<script>
import UserModal from './components/UserModal';
import {companyInfo} from "@/api/companyService";
import {showCity} from "@/utils/util";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {dictMixin} from "@/mixins";
import {sys_policy} from "@/api/policyService";

export default {
    name: "index",
    mixins: [dictMixin],
    components: {
        UserModal, DictRender
    },
    data() {
        return {
            dictNames: 'businessScope,corpbelong_type,affiliated_park',
            detail: {},
            listKeyField: "id",
        }
    },
    mounted() {
        this.getCorpInfo();
        this.getTwoCode()
    },
    methods: {
        getCorpInfo() {
            this.getAction({
                url: companyInfo.detail
            }).then(res => {
                this.detail = {
                    ...res,
                    provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''
                }
            })
        },
        getTwoCode() {
            this.getAction({
                url: sys_policy.getErCode
            }).then(res => {
                this.$ls.set('erweimaCode', res);
                // this.erweimaCode = res
            })
        },
        onEdit() {
            this.onShowModal('userModal', this.detail);
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        onCloseModel() {
            window.location.reload();
        }
    }
}
</script>

<style scoped lang="less">
.info-content {
    background: #fff;

    .content {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;

        .left, .middle, .right {
            width: 30%;
        }

        .left, .middle {
            border-right: 1px solid #F5F5F5;
        }

        .item {
            margin: 0 0 20px 0;

            .name {
                font-size: 14px;
                color: #999999;
                margin-bottom: 6px;
            }

            .value {
                font-size: 14px;
                color: #333333;

                a {
                    color: #0059B5;
                }

                img {
                    width: 16px;
                }
            }
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        border-bottom: 1px solid #DEDEDE;

        .btn {
            color: #999999;
            font-size: 14px;
            cursor: pointer;

            img {
                width: 15px;
                height: 15px;
                margin-bottom: 3px;
            }
        }

        .tit {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            padding-left: 10px;
            position: relative;

            &::before {
                content: '';
                display: block;
                width: 4px;
                height: 14px;
                background: #0059B5;
                border-radius: 2px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
    }
}

.top {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 30px;

    .imgBox {
        float: left;
        margin-right: 20px;
        width: 140px;
        height: 120px;
    }

    .rightBox {
        color: #333;
        width: 100%;

        .topBox {
            display: flex;
            align-items: center;

            .name {
                float: left;
                font-weight: 700;
                font-size: 22px;
            }

            .user-type {
                background: url("../../../../assets/home/user-type-01.png");
                background-size: 100% 100%;
                width: 100px;
                height: 30px;
                text-align: center;
                color: #fff;
                line-height: 30px;
                padding-left: 18px;
                margin-left: 8px;
            }

            .nameRight {
                float: left;
                margin-left: 25px;
                margin-top: 10px;
            }
        }

        .second {
            font-size: 16px;
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            align-items: center;

            .name {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }

            .name:first-child {
                padding-right: 20px;
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    width: 1px;
                    height: 15px;
                    background: #ccc;
                    position: absolute;
                    top: 5px;
                    right: 0;
                }
            }

            .name:last-child {
                padding-left: 20px;
            }
        }
    }
}
</style>
